import { DispatchDashboard, ShipmentsDashboard } from "@svan-garaaz/lmd";
import { withApiConfig } from "../hoc/withApiConfig";

const R2DOrdersWithEmptyRiders = withApiConfig(DispatchDashboard, {
  maskDeliveryContactDetails: true,
  userName: "Garaaz",
  enableDistanceTabs: true,
  refreshConfig: {
    enabled: true,
    intervalMinutes: 10,
  },
});

export const ApiAwareR2DOrders = R2DOrdersWithEmptyRiders;
export const ApiAwareShipmentsDashboard = withApiConfig(ShipmentsDashboard);
